<template>
    <div style="max-width: 100%">
        <v-btn-toggle dense>
            <v-btn :disabled="!focused" @mousedown="formatClear"><span><v-icon>format_clear</v-icon></span></v-btn>
            <v-btn :disabled="!focused" @mousedown="bold"><span><v-icon>format_bold</v-icon></span></v-btn>
            <v-btn :disabled="!focused" @mousedown="italic"><span class="font-italic"><v-icon>format_italic</v-icon></span></v-btn>
            <v-btn :disabled="!focused" @mousedown="underline"><span><v-icon>format_underline</v-icon></span></v-btn>
            <v-btn :disabled="!focused" @mousedown="pre"><span>code</span></v-btn>
            <v-btn :disabled="!focused" @mousedown="urlPasteVisible(true)">url</v-btn>
        </v-btn-toggle>
        <v-dialog v-model="urlPasteShow" max-width="300px">
            <v-card>
                <v-card-title>
                    <span class="headline"></span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="urlPasteObject.text" label="Значение переменной"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="urlPasteObject.url" label="Значение переменной"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="urlPasteVisible(false)">Отмена</v-btn>
                    <v-btn color="blue darken-1" text @click="urlPaste">Сохранить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row style="position: relative;">
            <label class="v-label v-label--active theme--light caption" style="left: 25px; right: auto; position: absolute;">Название сообщения</label>
            <div>
                <div style="display:inline-block;" class="ma-4 mb-0 pa-2"
                     contenteditable
                     v-html="textInEditor"
                     ref="textarea"
                     v-on:keyup.stop="enterHandle"
                     @focus="focused = true" @blur="focused = false"
                     tabindex="0"
                >
                </div>
            </div>
        </v-row>
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
    name: 'TextEditor',
    props: ['text'],
    data() {
        return {
            textInEditor: '',
            urlPasteObject: {
                text: '',
                url: '',
                start: 0,
                length: 0,
                range: null
            },
            urlPasteShow: false,
            focused: false
        }
    },
    methods: {
        bold() {
            document.execCommand('bold', false)
            this.$refs.textarea.focus()
            this.$nextTick(() => {
                this.$refs.textarea.focus()
            })
            this.updateText()
        },
        italic() {
            document.execCommand('italic', false)
            this.$refs.textarea.focus()
            this.$nextTick(() => {
                this.$refs.textarea.focus()
            })
            this.updateText()
        },
        underline() {
            document.execCommand('underline', false)
            this.$refs.textarea.focus()
            this.$nextTick(() => {
                this.$refs.textarea.focus()
            })
            this.updateText()
        },
        pre() {
            let range = window.getSelection().getRangeAt(0)
            let newBaitTag = document.createElement('code')
            newBaitTag.innerHTML = range.toString()
            range.deleteContents() // очищаем выделенное
            range.insertNode(newBaitTag)
            this.updateText()
        },
        formatClear() {
            let range = window.getSelection().getRangeAt(0)
            let clearedText = range.toString()
            range.deleteContents() // очищаем выделенное
            document.execCommand('insertText', false, clearedText)
            this.updateText()
        },
        enterHandle: function (e) { // Событие для любого ввода
            if (e.keyCode === 13) {
            }
            this.updateText()
            return true
        },
        handlePaste(event) { // Вставляем чистый текст без стилей
            event.preventDefault()
            const text = event.clipboardData.getData('text/plain')
            document.execCommand('insertText', false, text)
            this.updateText()
        },
        urlPasteVisible(value) {
            if (window.getSelection().rangeCount === 0) {
                return false
            }
            let selection = window.getSelection()
            this.urlPasteObject.text = selection.getRangeAt(0).toString()
            this.urlPasteObject.range = selection.getRangeAt(0)
            this.urlPasteShow = value
        },
        urlPaste() { // Вставляем ссылку
            this.urlPasteShow = false
            let newBaitTag = document.createElement('a')
            newBaitTag.setAttribute('href', this.urlPasteObject.url)
            newBaitTag.innerHTML = this.urlPasteObject.text
            this.urlPasteObject.range.deleteContents() // очищаем выделенное
            this.urlPasteObject.range.insertNode(newBaitTag)
            this.urlPasteObject.url = this.urlPasteObject.text = ''
            this.$nextTick(() => {
                this.$refs.textarea.focus()
            })
            this.updateText()
        },
        updateText() {
            let text = this.$refs.textarea.innerHTML.replace(/<br>/g, '\n').replace(/&nbsp;/g, ' ')
            this.$emit('updateText', text)
        }
    },
    watch: {
        text: {
            handler: function() {
                if (this.text) {
                    this.$nextTick(() => {
                        this.$refs.textarea.addEventListener('paste', this.handlePaste)
                    })
                    this.textInEditor = this.text.replace(/\n/g, '<br>')
                } else if (this.$refs.textarea) {
                    this.$refs.textarea.removeEventListener('paste', this.handlePaste)
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>
